import {
  AttachFile,
  FormatBold,
  FormatItalic,
  FormatUnderlined,
} from "@mui/icons-material";
import AddTaskIcon from "@mui/icons-material/AddTask";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  createTheme,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ThemeProvider,
  useTheme,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import React, { act, useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Quill Styles
import { Link } from "react-router-dom";
import {
  ARTICLE_ATTACHMENT_URL,
  ARTICLE_REFERENCE_URL,
  ARTICLE_URL,
  CATEGORY_URL,
  SUB_CATEGORY_BY_CAT_URL,
} from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import { useAlert } from "./../alerts/AlertContext";
import { isEmpty } from "../../Constants/RolesConstants";

// Custom Toolbar Configuration
const CustomToolbar = () => (
  <div id="toolbar">
    <button className="ql-bold">
      <FormatBold />
    </button>
    <button className="ql-italic">
      <FormatItalic />
    </button>
    <button className="ql-underline">
      <FormatUnderlined />
    </button>
    <select className="ql-header">
      <option value="1">Heading 1</option>
      <option value="2">Heading 2</option>
      <option value="">Normal</option>
    </select>
  </div>
);

function ArticleDialog({
  articleId,
  selectedArticleName,
  callArticles,
  componentPermissions,
  actionType,
  isEdit
}) {
  const globaltheme = useTheme();
  const theme = createTheme({
    ...globaltheme,
    components: {
      MuiSelect: {},
    },
  });

  const showAlert = useAlert();
  const [open, setOpen] = React.useState(false);
  const [content, setContent] = useState(""); // Stores email content
  const [attachments, setAttachments] = useState([]); // Stores attachments
  const [active, setActive] = useState(true);
  const [protect, setProtect] = useState(true);

  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [visible, setVisible] = useState(true);
  const [global, setGlobal] = useState(true);

  const [ratingOne, setRatingOne] = useState(0);
  const [ratingTwo, setRatingTwo] = useState(0);
  const [ratingThree, setRatingThree] = useState(0);
  const [ratingFour, setRatingFour] = useState(0);
  const [ratingFive, setRatingFive] = useState(0);

  const [urls, setUrls] = useState([]);
  const [url, setUrl] = useState("");

  const [category, setCategory] = useState();
  const [categories, setCategories] = useState([]);

  const [subCategory, setSubCategory] = useState();
  const [subCategories, setSubCategories] = useState([]);

  const [article, setArticle] = useState({
    category: {},
    subCategory: {},
    protect: true,
    title: "",
    summary: "",
    solutionSteps: "",
    visibleUser: true,
    global: true,
    active: true,
  });

  const [articleReferenceURLDTO, setArticleReferenceURLDTO] = useState({
    articleId: "",
    referenceURL: [],
  });

  useEffect(() => {
    getCategories();
  }, []);

  // Handle file selection
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAttachments([...attachments, file]);
    }
  };

  // Function to validate URL
  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  // Add URL to the list
  const handleAddUrl = () => {
    if (url && isValidUrl(url)) {
      setUrls([...urls, url]);
      setUrl(""); // Reset input field
    } else {
      showAlert("Please enter a valid URL!", "error");
    }
  };

  // Delete URL from the list
  const handleDeleteUrl = (index) => {
    setUrls(urls.filter((_, i) => i !== index));
  };

  const removeFile = (index) => {
    setAttachments(attachments.filter((_, i) => i !== index));
  };

  const handleClickOpen = () => {
    if (isEdit === true) {
      getArticle();
    } else {
      setOpen(true);
    }

  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleStatusChange = (event) => {
    setActive(event.target.value);
  };

  const handleProtectChange = (event) => {
    setProtect(event.target.value);
  };

  const handleGlobalChange = (event) => {
    setGlobal(event.target.value);
  };

  const handleUserVisibleChange = (event) => {
    setVisible(event.target.value);
  };

  const handleSummaryChange = (event) => {
    setSummary(event.target.value);
  };

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
    if (event.target.value !== null && event.target.value !== "") {
      getSubCategories(event.target.value);
    }
  };

  const handleSubCategoryChange = (event) => {
    setSubCategory(event.target.value);
  };

  const getCategories = async () => {
    await AxiosInstance.get(CATEGORY_URL).then((response) =>
      setCategories(response.data.data)
    );
  };

  const getSubCategories = async (catId) => {
    await AxiosInstance.get(SUB_CATEGORY_BY_CAT_URL + catId).then(
      (response) => {
        setSubCategories(Array.from(response.data.data));
        console.log(response.data.data);
      }
    );
  };

  const getArticle = async () => {
    await AxiosInstance.get(`${ARTICLE_URL}/${encodeURIComponent(articleId)}`).then(
      (response) => {
        var articleData = response.data.data;
        setArticle(articleData);
        setTitle(articleData.title);
        setSummary(articleData.summary);
        setVisible(articleData.visibleUser);
        setGlobal(articleData.global);
        setProtect(articleData.protect);
        setCategory(articleData.category.id);
        if (articleData.category.id !== null && articleData.category.id !== "") {
          getSubCategories(articleData.category.id);
        }

        setContent(articleData.solutionSteps);

        setActive(articleData.active);
        setOpen(true);
      }
    );
  };

  const handleSave = () => {
    const payload = {};
    payload.category = { id: category };
    payload.subCategory = { id: subCategory };
    payload.protect = protect;
    payload.title = title;
    payload.summary = summary;
    payload.solutionSteps = content;
    payload.visibleUser = visible;
    payload.global = global;
    payload.active = active;

    if (isEdit) {
      updateArticle(payload);
    } else {
      saveArticle(payload);
    }
  };


  const saveArticle = async (payload) => {
    //payload.id = 0;
    await AxiosInstance.post(ARTICLE_URL, payload)
      .then((response) => {
        saveReferenceURL(response.data.data.id);
        saveAttachment(response.data.data.id);
        showAlert("Article created successfully!", "success");
        callArticles();
      })
      .catch((error) => {
        showAlert("Article creation failed!", "error");
        console.error(error);
      });
  };

  const updateArticle = async (payload) => {

    await AxiosInstance.put(`${ARTICLE_URL}/${encodeURIComponent(articleId)}`, payload)
      .then((response) => {
        saveReferenceURL(response.data.data.id);
        saveAttachment(response.data.data.id);
        showAlert("Article updated successfully!", "success");
        callArticles();
      })
      .catch((error) => {
        showAlert("Article updation failed!", "error");
        console.error(error);
      });
  };


  const saveReferenceURL = async (articleId) => {
    if (urls.length > 0) {
      articleReferenceURLDTO.articleId = articleId;
      articleReferenceURLDTO.referenceURL = urls;

      await AxiosInstance.post(ARTICLE_REFERENCE_URL, articleReferenceURLDTO)
        .then((response) => {
          console.log("Reference URL's saved successfully!");
        })
        .catch((error) => {
          showAlert("Reference URL's creation failed!", "error");
          console.error(error);
        });
    }
  };

  const saveAttachment = async (articleId) => {
    let formData = new FormData();
    if (attachments.length > 0) {
      formData.append("file", attachments[0]);
      formData.append("articleId", articleId);
      AxiosInstance.post(ARTICLE_ATTACHMENT_URL, formData, {
        ...(AxiosInstance.defaults.headers["Content-Type"] =
          "multipart/form-data"),
      })
        .then((response) => {
          //alert("Mail Sent successfully");
          console.log("Article attachment saved successfully");
        })
        .catch((error) => {
          showAlert("Save attachment failed!", "error");
          console.error(error);
        });
    };
  }

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        {articleId === 0 ? (
          <>        
          < Tooltip
            title="Add Article"
            onClick={handleClickOpen}
            style={{
              cursor: "pointer",
              margin: "5px 0px",
              float: "right",
            }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>
          </>
  ) : (
    <Link onClick={handleClickOpen}>{selectedArticleName}</Link>
        )
}

<Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            sx: {
              width: 800, // fixed width
              maxWidth: "100%", // optional for responsiveness
            },
            onSubmit: (event) => {
              event.preventDefault();
              (isEmpty(componentPermissions) ||
                componentPermissions ?.["canUpdate"] ||
                  componentPermissions ?.["canCreate"]) &&
                handleSave();
              handleClose();

            },
          }}
        >
          <DialogTitle >{actionType} Article</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{ "& .MuiDialog-paper": { m: 1 } }}
              noValidate
              autoComplete="off"
            >
              <TextField
                autoFocus
                fullWidth
                required
                margin="dense"
                id="outlined-multiline-static"
                name="Title"
                label="Title"
                type="text"
                variant="standard"
                onChange={handleTitleChange}
                style={{ width: "100%", marginBottom: 15 }}
                value={title}
              //value={ticket.subject}
              />

              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="Summary"
                label="Summary"
                placeholder="Summary"
                fullWidth
                multiline
                rows={4}
                cols={10}
                value={summary}
                onChange={handleSummaryChange}
                style={{ width: "100%" }}
              />

              <Grid container spacing={2} columns={16}>
                <Grid size={8}>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      Category
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={category}
                      onChange={handleCategoryChange}
                      label="Category"
                    >
                      <MenuItem value="">
                        {" "}
                        <em>None </em>{" "}
                      </MenuItem>
                      {categories.map((cat) => (
                        <MenuItem key={cat.id} value={cat.id}>
                          {cat.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={8}>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      Sub Category
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={subCategory}
                      onChange={handleSubCategoryChange}
                      label="subCategory"
                    >
                      <MenuItem value="">
                        {" "}
                        <em>None </em>{" "}
                      </MenuItem>
                      {subCategories.map((subCat) => (
                        <MenuItem value={subCat.id}>{subCat.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* Attach File Button */}

              <Grid container spacing={2} columns={16}>
                <Grid size={6}>
                  <input
                    type="file"
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                    id="file-upload"
                  />
                  <label htmlFor="file-upload">
                    <Button
                      size="small"
                      component="span"
                      variant="contained"
                      startIcon={<AttachFile />}
                      sx={{ mb: 2 }}
                    >
                      Attach File
                    </Button>
                  </label>
                </Grid>
                <Grid size={10}>
                  {/* List of Attachments */}
                  {attachments.length > 0 && (
                    <div>
                      {/* <h5>Selected files:</h5> */}
                      <ul>
                        {attachments.map((file, index) => (
                          <li key={index}>
                            <span>{file.name}</span>&nbsp;&nbsp;
                            <CloseIcon
                              style={{ cursor: "pointer" }}
                              onClick={() => removeFile(index)}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </Grid>
              </Grid>
              <Paper
                elevation={3}
                sx={{ p: 2, borderRadius: "10px", border: "1px solid #ccc" }}
              >
                <CustomToolbar />
                <ReactQuill
                  theme="snow"
                  value={content}
                  onChange={setContent}
                  modules={{
                    toolbar: {
                      container: "#toolbar",
                    },
                  }}
                  style={{ height: "150px" }}
                />
              </Paper>
              <br />
              {/* <div style={{ maxWidth: 500, margin: "auto", textAlign: "center", padding: 20 }}> */}
              <Grid container spacing={2} columns={16}>
                <Grid size={12}>
                  <TextField
                    label="Enter Reference URL"
                    variant="outlined"
                    fullWidth
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    style={{ marginBottom: 10 }}
                  />
                </Grid>
                <Grid size={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddUrl}
                  >
                    Add URL
                  </Button>
                </Grid>
              </Grid>

              <List>
                {urls.map((u, index) => (
                  <ListItem
                    key={index}
                    secondaryAction={
                      <IconButton
                        edge="end"
                        onClick={() => handleDeleteUrl(index)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    }
                  >
                    <ListItemText primary={u} />
                  </ListItem>
                ))}
              </List>
              {/* </div> */}
              <br />
              <Grid container spacing={2} columns={16}>
                <Grid size={8}>
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">
                      Protect
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={protect}
                      onChange={handleProtectChange}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid size={8}>
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">
                      Global
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={global}
                      onChange={handleGlobalChange}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2} columns={16}>
                <Grid size={8}>
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">
                      User Visible
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={visible}
                      onChange={handleUserVisibleChange}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid size={8}>
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">
                      Active
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={active}
                      onChange={handleStatusChange}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            {actionType === "Add" ? <Button type="submit">Add </Button> : null}
            {actionType === "Edit" &&
              (isEmpty(componentPermissions) ||
                componentPermissions ?.["canUpdate"]) ? (
                <Button type="submit">Add </Button>
              ) : null}
          </DialogActions>
        </Dialog>
      </React.Fragment >
    </ThemeProvider >
  );
}
export default ArticleDialog;
